export function base64encode(text: string) {
  let bytes = new TextEncoder().encode(text);
  const binString = String.fromCodePoint(...bytes);
  return btoa(binString);
}

export function base64decode(baseText: string) {
  const binString = atob(baseText);
  let bytes = Uint8Array.from(binString, (m) => m.codePointAt(0)!);
  return new TextDecoder().decode(bytes);
}

export async function base64toByteArray(base64data: string) {
  const binaryString = atob(base64data); // Decode base64 string to binary string
  const len = binaryString.length;
  const bytes = new Uint8Array(len); // Create a Uint8Array to hold the bytes

  // Convert the binary string to byte array
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer; // Return the ArrayBuffer
}

export async function hash(byteArray: ArrayBuffer) {
  return await crypto.subtle.digest('SHA-256', byteArray);
}

export async function encrypt(
  byteArray: ArrayBuffer,
  key: CryptoKey,
  iv: ArrayBuffer
) {
  return await crypto.subtle.encrypt(
    { name: 'AES-CBC', iv: iv },
    key,
    byteArray
  );
}

export async function decrypt(
  byteArray: ArrayBuffer,
  key: CryptoKey,
  iv: ArrayBuffer
) {
  return await crypto.subtle.decrypt(
    { name: 'AES-CBC', iv: iv },
    key,
    byteArray
  );
}

export async function convertKey(byteArray: ArrayBuffer) {
  return await crypto.subtle.importKey(
    'raw',
    byteArray,
    { name: 'AES-CBC' },
    false,
    ['encrypt', 'decrypt']
  );
}

export function concatenateByteArrays(uint8arrays: Uint8Array[]) {
  const totalLength = uint8arrays.reduce(
    (total, uint8array) => total + uint8array.byteLength,
    0
  );
  const result = new Uint8Array(totalLength);
  let offset = 0;
  uint8arrays.forEach((uint8array) => {
    result.set(uint8array, offset);
    offset += uint8array.byteLength;
  });
  return result;
}

export async function byteArrayToBase64(byteArray: ArrayBuffer) {
  const file = new File([byteArray], 'temp.bin', {
    type: 'application/octet-stream',
  });
  const fileReader = new FileReader();
  const dataUrl = await new Promise<string>((resolve, reject) => {
    fileReader.onload = () => resolve(fileReader.result as string);
    fileReader.onerror = () => reject(fileReader.error);
    fileReader.readAsDataURL(file);
  });
  return dataUrl.split('base64,')[1];
}

export async function generateCommunityToken(
  sid: string,
  keyBase: string,
  password: string
) {
  // real encode test - required for b2b/auth/getOneTimeToken
  const ivBase = base64encode(sid.substring(0, 16)); // trim to match AES 128 bit key size of 16 single byte chars and convert it to base64
  // JS matches IV generated by APEX (base iv)
  const passwordBase = base64encode(password); // convert to base64
  const passwordBuffer = await base64toByteArray(passwordBase); // convert to binary buffer
  const ivBuffer = await base64toByteArray(ivBase); // convert to binary buffer
  const keyBuffer = await base64toByteArray(keyBase); // convert to binary buffer
  const key = await convertKey(keyBuffer); // convert to be instance of Crypto Key
  // full-encryption to fit requirement
  // steps/format: bufferBase(encrypt(bufferBase(textBase(password))) + '|' + bufferBase(encrypt(hash(textBase(password))))
  const passwordHashBuffer = await hash(passwordBuffer); // SHA-256
  const hashBase = await byteArrayToBase64(passwordHashBuffer); // convert to base 64 string
  const passwordEncryptedBuffer = await encrypt(passwordBuffer, key, ivBuffer); // encrypt - output is binary buffer
  const passwordHashEncryptedBuffer = await encrypt(
    passwordHashBuffer,
    key,
    ivBuffer
  ); // encrypt - output is binary buffer
  const passwordEncryptedBufferBase = await byteArrayToBase64(
    passwordEncryptedBuffer
  ); // convert to base 64 string
  const passwordHashEncryptedBufferBase = await byteArrayToBase64(
    passwordHashEncryptedBuffer
  ); // convert to base 64 string
  const finalContent =
    passwordEncryptedBufferBase + '|' + passwordHashEncryptedBufferBase;
  console.log(finalContent);
  return finalContent;
  // is "DnNleo7G83XmRzpDKgxmYCE9vUJ2wbp+FOBudESgm5A=|GJ/BYY6Anl8u3cGzWiCeuZY1tYEw9xxY7c0oXrJB3iVKPzju3amftzbLdvensESp"
}
